import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const TestManagementLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./test-management-page'),
});
